export const MUTATION_TYPES = {
    SET_CALCULATOR_FORMULA: 'setCalculatorFormula',
    APPEND_CALCULATOR_FORMULA: 'appendCalculatorFormula',
    DROP_CALCULATOR_FORMULA: 'dropCalculatorFormula',
    CLEAR_CALCULATOR_FORMULA: 'clearCalculatorFormula',
    SET_CALCULATOR_VALUE: 'setCalculatorValue',
    ADD_SEND_MOSAIC: 'addSendMosaic',
    REMOVE_SEND_MOSAIC: 'removeSendMosaic',
    CLEAR_SEND_MOSAIC: 'clearSendMosaic',
    SET_RECEIVER_ADDRESS: 'setReceiverAddress',
    CLEAR_RECEIVER_ADDRESS: 'clearReceiverAddress',
    SET_RECEIVER_PUBLIC_KEY: 'setReceiverPublicKey',
    CLEAR_RECEIVER_PUBLIC_KEY: 'clearReceiverPublicKey',
    SET_SEND_MESSAGE: 'setSendMessage',
    CLEAR_SEND_MESSAGE: 'clearSendMessage',
    SET_MESSAGE_ENCRYPTION: 'setMessageEncryption',
    SET_BACK_PATH_FROM_WALLET_SELECT: 'setBackPathFromWalletSelect',
    SET_BACK_PATH_FROM_LESSON: 'setBackPathFromLesson',
    SET_BACK_PATH_FROM_KEY: 'setBackPathFromKey',
    SET_BACK_PATH_FROM_SEND_CONFIRMATION: 'setBackPathFromSendConfirmation',
    SET_TRANSACTION: 'setTransaction',
    SETUP_TYPES: 'setupTypes',
};



//////////////////
// WEBPACK FOOTER
// ./src/lib/mutationTypes.ts
// module id = 27
// module chunks = 1